/* Shared text/layout helpers used across pages. */
.muted {
  color: var(--color-grey);
  font-size: var(--font-size-s);
}
